import { createSelector } from 'reselect';
import findWhere from 'selectors/findWhere.js';

const devices = state => state.devices.models;
const measurementIds = state => state.measurements.ids;
const measurements = state => state.measurements.models;

export const selectWiseButtons = rootDeviceId => createSelector(
    devices,
    measurements,
    (devices, measurements) => {
        if (!rootDeviceId) {
            console.error('selectWiseButtons: rootDeviceId is not provided');
            return [];
        }

        return Object.values(measurements).filter(measurement => {
            const device = devices[measurement.device_id];

            if (!device || device.root_device_id !== rootDeviceId || device.equipment_category_slug !== 'wise_input') {
                return false;
            }

            return measurement.extra['input_kind'] === 'wise_button';
        });
    }
);

export const selectWiseButtonsForDevice = deviceId =>
    createSelector(
        [
            selectMeasurementsByDevice(deviceId),
            measurements
        ],
        (deviceMeasurements, allMeasurements) => {
            if (!deviceMeasurements) {
                return [];
            }

            return deviceMeasurements
                .filter(m => m.wise_button_id)
                .map(m => allMeasurements[m.wise_button_id])
                .filter(Boolean);
        }
    );

export const selectMeasurementsByDevice = deviceId => createSelector(
    [measurementIds, measurements],
    (ids, models) => findWhere(ids.map(id => models[id]), { device_id: deviceId })
);

export const selectMeasurementsByDeviceIdMap = deviceId => createSelector(
    [selectMeasurementsByDevice(deviceId)],
    deviceMeasurements => {
        const map = {};
        deviceMeasurements.forEach(measurement => {
            map[measurement.id] = measurement;
        });
        return map;
    }
);
